<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'

const { t } = useI18n()

const props = defineProps<{ compact?: boolean }>()

const version = document.querySelector<HTMLMetaElement>('meta[name="app-version"]')?.content ?? 'unknown'
const year = new Date().getFullYear()
const supportEmail = 'support@gtsu.org'
</script>

<template>
  <footer class="shrink-0 px-6 py-2 border-t border-surface-200 dark:border-surface-700 flex items-center justify-between text-xs text-surface-400 dark:text-surface-500 bg-surface-0 dark:bg-surface-900 gap-4">

    <!-- compact: name + version only -->
    <template v-if="props.compact">
      <span class="shrink-0 flex items-center gap-2">
        <span class="font-medium text-surface-500 dark:text-surface-400">supervisor-ng</span>
        <span class="font-mono bg-surface-100 dark:bg-surface-800 px-1.5 py-0.5 rounded text-surface-400 dark:text-surface-500">v{{ version }}</span>
      </span>
      <a
        :href="`mailto:${supportEmail}`"
        class="hover:text-primary-600 dark:hover:text-primary-400 transition-colors shrink-0"
      >{{ supportEmail }}</a>
    </template>

    <!-- full: name + version + copyright + VAT + legal links -->
    <template v-else>
      <span class="shrink-0 flex items-center gap-2 flex-wrap">
        <span class="font-medium text-surface-500 dark:text-surface-400">supervisor-ng</span>
        <span class="font-mono bg-surface-100 dark:bg-surface-800 px-1.5 py-0.5 rounded text-surface-400 dark:text-surface-500">v{{ version }}</span>
        <span class="text-surface-300 dark:text-surface-600">·</span>
        <span>© {{ year }} Tecnica - Formazione - Sicurezza s.r.l. · P.IVA IT00649260072</span>
      </span>
      <nav class="flex items-center gap-4 flex-wrap justify-end shrink-0">
        <RouterLink
          to="/trust"
          class="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
        >{{ t('footer.trustCenter') }}</RouterLink>
        <a
          :href="`mailto:${supportEmail}`"
          class="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
        >{{ t('footer.support') }}</a>
      </nav>
    </template>

  </footer>
</template>
